(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoService', ReporteEvaluativoService);

    ReporteEvaluativoService.$inject = ['$resource'];

    function ReporteEvaluativoService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo:search,:type,:indice,:ic,:iic,:anio,:modelo,:nivel,:centro,:ep';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'reportesMasivos': { 
            	url:'apo/reportesEvaluativosMasivos:search,:type,:indice,:ic,:iic,:anio,:modelo,:nivel,:centro',
            	method:'GET',
            	isArray: true
            		
            }
        });
    }
})();
